import request from '../../http.js';
//登录
export function login(username, password) {
    return request({
        url: "/api/admin/login",
        method: 'post',
        data: {
            name: username,
            pwd: password,
        },
    })
}
//退出登录
export function exit() {
    return request({
        url: "/api/admin/logout",
        method: 'get',
    })
}
// 验证是否登录
export function loginvalidation() {
    return request({
        url: "/api/admin/adminInfo",
        method: 'get',
    })
}

//相机列表----------------------------
// 获取相机型号
export function getmodel() {
    return request({
        url: "/api/admin/cmodel",
        method: 'get',
    })
}
// 添加相机
export function addCamera(imei, model) {
    return request({
        url: "/api/admin/cbindAdd",
        method: 'post',
        data: {
            imei: imei,
            mid: model,
        }
    })
}
// 删除相机
export function delCamera(cbid) {
    return request({
        url: "/api/admin/cbindDel",
        method: 'post',
        data: {
            cbid,
        }
    })
}
//获取相机列表
export function getlist(page) {
    return request({
        url: "/api/admin/cbind",
        method: 'post',
        data: {
            page: page,
        }
    })
}

//获取相机列表2
export function userCamera(page) {
    return request({
        url: "/api/admin/userCamera",
        method: 'post',
        data: {
            page: page
        }
    })
}
// 按imei号搜索绑定相机
export function imeisearch(imei) {
    return request({
        url: "/api/admin/cbindSch",
        method: 'post',
        data: {
            imei: imei,
        }
    })
}

// 按imei号搜索绑定相机
export function searchUserCa(imei) {
    return request({
        url: "/api/admin/searchUserCa",
        method: 'post',
        data: {
            imei: imei,
        }
    })
}

//中心页搜索
export function searchM(email) {
    return request({
        url: "/api/admin/searchM",
        method: 'post',
        data: {
            email: email,
        }
    })
}

//用户中心--------------------------------
// 获取用户列表
export function userlist(page) {
    return request({
        url: "/api/admin/Members",
        method: 'post',
        data: {
            page: page,
        }
    })
}
// 用户详情
export function userDetails(id) {
    return request({
        url: "/api/admin/mCameras",
        method: 'post',
        data: {
            uid: id,
        }
    })
}

//管理员一键清空用户相机拍摄数据
export function ManagementsDel(data) {
    return request({
        url: '/api/admin/FsallDel',
        method: 'post',
        data
    })
}

//管理员解绑用户相机
export function ManageUnbind(data) {
    return request({
        url: '/api/admin/Unbcam',
        method: 'post',
        data
    })
}

//获取banner列表
export function getBanner() {
    return request({
        url: "/api/admin/hBanner",
        method: 'get',
    })
}

//banner的开启或关闭状态
export function bannerStatus(bid, status) {
    return request({
        url: "/api/admin/Bstatus",
        method: 'post',
        data: {
            bid,
            status
        }
    })
}

//添加banner图片数据
export function addBanner(data) {
    return request({
        url: "/api/admin/addBanner",
        method: 'post',
        data,
        timeout: 6000,
        headers: {//请求头的修改
            'Content-Type': 'multipart/form-data'
        }
    })
}

//删除banner图片数据
export function delBanner(data) {
    return request({
        url: "/api/admin/delBan",
        method: 'post',
        data
    })
}

//获取编辑的数据
export function getEditBanner(data) {
    return request({
        url: "/api/admin/editBid",
        method: 'post',
        data
    })
}

//保存的编辑数据
export function saveEditBanner(data) {
    return request({
        url: "/api/admin/saveEdid",
        method: 'post',
        data,
        timeout: 6000,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}


// WEBPACK FOOTER //
// ./src/https/api/admin/index.js